var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.37 30.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f98050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.19,30.37C6.81,30.37,0,23.56,0,15.19S6.81,0,15.19,0s15.19,6.81,15.19,15.19-6.81,15.19-15.19,15.19Zm0-28.05C8.1,2.33,2.33,8.1,2.33,15.19s5.77,12.86,12.86,12.86,12.86-5.77,12.86-12.86S22.28,2.33,15.19,2.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.19,
    cy: 14.91,
    r: 10.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRec);
export default __webpack_public_path__ + "static/media/rec.002bba242c49d3949d3c41fb24b3c316.svg";
export { ForwardRef as ReactComponent };